var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraDisabled = function SvgCameraDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.31 4.687a.663.663 0 0 1 .93-.113L5.313 6.2h6.571a1.77 1.77 0 0 1 1.766 1.766v4.773l3.974 3.113v-7.32l-3.091 1.394V8.474l2.878-1.294a1.09 1.09 0 0 1 1.537.994v8.715l.629.494a.66.66 0 0 1-.083 1.099.66.66 0 0 1-.734-.056L2.423 5.617a.663.663 0 0 1-.113-.93m10.016 7.008V7.966a.443.443 0 0 0-.442-.442H7.005zM3.053 7.966c0-.06 0-.12.008-.179l1.314 1.035v6.21a.443.443 0 0 0 .442.442h7.067a.44.44 0 0 0 .439-.389l1.079.85a1.77 1.77 0 0 1-1.518.864H4.819a1.77 1.77 0 0 1-1.766-1.768z"
  })));
};
export default SvgCameraDisabled;